<template>
  <div class="loverSortBox">
    <div class="custom">
      <div class="fx" v-if="showSettlementMethod && settlementMethodList && settlementMethodList.length > 0">
        <div class="title">结算方式</div>
        <div class="material selectBox">
          <el-radio-group
            v-model="dataFrom.settlementMethod"
            size="small"
            @change="getSizeRange($event, 'settlementMethod', spotActive == 'first' ? '女' : '男')"
          >
            <span class="inchesFix">
              <el-radio-button
                v-for="item in settlementMethodList"
                :key="item.value"
                :disabled="(!dropDownOptional.materStockQuantity || dropDownOptional.materStockQuantity <= 0) && item.value == 2"
                :value="item.value"
                :label="item.value"
              >
                {{ item.label }}
              </el-radio-button>
            </span>
          </el-radio-group>
        </div>
      </div>
    </div>

    <div class="spotTabs">
      <el-tabs v-model="spotActive" type="card" @tab-click="handleClick">
        <el-tab-pane label="女款" name="first"></el-tab-pane>
        <el-tab-pane label="男款" name="second"></el-tab-pane>
      </el-tabs>
    </div>

    <div class="custom" v-if="spotActive == 'first'">
      <div class="fx" v-if="formatTypes && formatTypes.length > 0">
        <div class="title">版型</div>
        <div class="material selectBox">
          <el-radio-group v-model="dataFrom.formatType" size="small" @change="getSizeRange($event, 'formatType', '女')">
            <span class="inchesFix">
              <el-radio-button v-for="item in formatTypes" :key="item" :value="item" :label="item">{{ item }}</el-radio-button>
            </span>
          </el-radio-group>
        </div>
      </div>
      <div class="fx" v-if="lcTechnologList && lcTechnologList.length > 0">
        <div class="title">鎏彩工艺</div>
        <div class="material selectBox">
          <el-radio-group v-model="dataFrom.lcTechnology" size="small" @change="getSizeRange($event, 'lcTechnology', '女')">
            <span class="inchesFix">
              <el-radio-button v-for="item in lcTechnologList" :key="item" :value="item" :label="item">{{ item }}</el-radio-button>
            </span>
          </el-radio-group>
        </div>
      </div>
      <div class="fx" v-if="goldenWeighList && goldenWeighList.length > 0">
        <div class="title">金重</div>
        <div class="material selectBox">
          <el-radio-group v-model="dataFrom.goldWeigh" size="small" @change="getSizeRange($event, 'goldWeigh', '女')">
            <span class="inchesFix">
              <el-radio-button v-for="item in goldenWeighList" :key="item" :value="item" :label="item">{{ item }}</el-radio-button>
            </span>
          </el-radio-group>
        </div>
      </div>
      <div class="fx" v-if="handSizeList && handSizeList.length > 0">
        <div class="title">
          规格
          <span class="inchesTips" v-if="handSizeList && handSizeList[0].includes('寸')">(1英寸=2.54厘米)</span>
        </div>
        <div class="material selectBox">
          <el-radio-group v-model="dataFrom.ringSize" size="small" @change="getSizeRange($event, 'ringSize', '女')">
            <span class="inchesFix">
              <el-radio-button v-for="item in handSizeList" :key="item" :value="item" :label="item">{{ item }}</el-radio-button>
            </span>
          </el-radio-group>
        </div>
      </div>
      <div class="textareaRemark">
        <div class="title">备注</div>
        <el-input
          v-model="dataFrom.productRemark"
          :rows="6"
          :maxlength="64"
          type="textarea"
          placeholder="其他要求与说明请在此处备注说明，字符数限制64位"
        ></el-input>
      </div>
      <div class="box_detail_input price-wrap">
        <div
          class="price-tips"
          v-if="
            (tradePrice && hasPriceViewPermission()) ||
            (labelPrice && (!dataFrom.exclusivePrice || dataFrom.exclusivePrice == 0)) ||
            (dataFrom.exclusivePrice && dataFrom.exclusivePrice != 0)
          "
        >
          (预估价格，实际价格请以结算为准)
        </div>
        <div>
          <div class="box_detail_input marginFx" v-if="settlementWeight && dataFrom.settlementMethod == 2">
            <div class="input-wrap">结算金重：{{ settlementWeight }}</div>
          </div>
          <div class="box_detail_input marginFx" v-if="tradePrice && hasPriceViewPermission()">
            <div class="input-wrap">{{ dataFrom.settlementMethod == 2 ? '结算工费' : '结算金额' }}：{{ tradePrice }}</div>
          </div>
          <div class="box_detail_input marginFx" v-if="labelPrice && (!dataFrom.exclusivePrice || dataFrom.exclusivePrice == 0)">
            <div class="input-wrap">标签价格：{{ labelPrice }}</div>
          </div>
          <div class="box_detail_input marginFx" v-if="dataFrom.exclusivePrice && dataFrom.exclusivePrice != 0 && dataFrom.settlementMethod != 2">
            <div class="input-wrap">尊享价：{{ dataFrom.exclusivePrice }}</div>
          </div>
        </div>
      </div>
      <div class="box_detail_input marginFx">
        <div class="input-wrap">
          <span class="prompt"
            >库存{{ dropDownOptional.stockQuantity || 0 }}件<span class="inchesTips">（情侣款需成对下单）</span>，可选择不同规格</span
          >
          <span class="prompt placeNum">购买数量：</span>
          <el-input-number
            v-model="dataFrom.quantity"
            :min="dropDownOptional.stockQuantity > 0 ? 1 : 0"
            :max="stockQuantity"
            label="描述文字"
            @change="getSizeRange($event, 'quantity', '女')"
          ></el-input-number>
        </div>
      </div>
    </div>

    <div class="custom" v-if="spotActive == 'second'">
      <div class="fx" v-if="maleFormatTypes && maleFormatTypes.length > 0">
        <div class="title">版型</div>
        <div class="material selectBox">
          <el-radio-group v-model="maleDataFrom.formatType" size="small" @change="getSizeRange($event, 'formatType', '男')">
            <span class="inchesFix">
              <el-radio-button v-for="item in maleFormatTypes" :key="item" :value="item" :label="item">{{ item }}</el-radio-button>
            </span>
          </el-radio-group>
        </div>
      </div>
      <div class="fx" v-if="maleLcTechnologList && maleLcTechnologList.length > 0">
        <div class="title">鎏彩工艺</div>
        <div class="material selectBox">
          <el-radio-group v-model="maleDataFrom.lcTechnology" size="small" @change="getSizeRange($event, 'lcTechnology', '男')">
            <span class="inchesFix">
              <el-radio-button v-for="item in maleLcTechnologList" :key="item" :value="item" :label="item">{{ item }}</el-radio-button>
            </span>
          </el-radio-group>
        </div>
      </div>
      <div class="fx" v-if="maleGoldenWeighList && maleGoldenWeighList.length > 0">
        <div class="title">金重</div>
        <div class="material selectBox">
          <el-radio-group v-model="maleDataFrom.goldWeigh" size="small" @change="getSizeRange($event, 'goldWeigh', '男')">
            <span class="inchesFix">
              <el-radio-button v-for="item in maleGoldenWeighList" :key="item" :value="item" :label="item">{{ item }}</el-radio-button>
            </span>
          </el-radio-group>
        </div>
      </div>
      <div class="fx" v-if="maleHandSizeList && maleHandSizeList.length > 0">
        <div class="title">
          规格
          <span class="inchesTips" v-if="maleHandSizeList && maleHandSizeList[0].includes('寸')">(1英寸=2.54厘米)</span>
        </div>
        <div class="material selectBox">
          <el-radio-group v-model="maleDataFrom.ringSize" size="small" @change="getSizeRange($event, 'ringSize', '男')">
            <span class="inchesFix">
              <el-radio-button v-for="item in maleHandSizeList" :key="item" :value="item" :label="item">{{ item }}</el-radio-button>
            </span>
          </el-radio-group>
        </div>
      </div>
      <div class="textareaRemark">
        <div class="title">备注</div>
        <el-input
          v-model="maleDataFrom.productRemark"
          :rows="6"
          :maxlength="64"
          type="textarea"
          placeholder="其他要求与说明请在此处备注说明，字符数限制64位"
        ></el-input>
      </div>
      <div class="box_detail_input price-wrap">
        <div
          class="price-tips"
          v-if="
            (maleTradePrice && hasPriceViewPermission()) ||
            (malelLabelPrice && (!maleDataFrom.exclusivePrice || maleDataFrom.exclusivePrice == 0)) ||
            (maleDataFrom.exclusivePrice && maleDataFrom.exclusivePrice != 0)
          "
        >
          (预估价格，实际价格请以结算为准)
        </div>
        <div>
          <div class="box_detail_input marginFx" v-if="maleSettlementWeight && maleDataFrom.settlementMethod == 2">
            <div class="input-wrap">结算金重：{{ maleSettlementWeight }}</div>
          </div>
          <div class="box_detail_input marginFx" v-if="maleTradePrice && hasPriceViewPermission()">
            <div class="input-wrap">{{ maleDataFrom.settlementMethod == 2 ? '结算工费' : '结算金额' }}：{{ maleTradePrice }}</div>
          </div>
          <div class="box_detail_input marginFx" v-if="malelLabelPrice && (!maleDataFrom.exclusivePrice || maleDataFrom.exclusivePrice == 0)">
            <div class="input-wrap">标签价格：{{ malelLabelPrice }}</div>
          </div>
          <div
            class="box_detail_input marginFx"
            v-if="maleDataFrom.exclusivePrice && maleDataFrom.exclusivePrice != 0 && maleDataFrom.settlementMethod != 2"
          >
            <div class="input-wrap">尊享价：{{ maleDataFrom.exclusivePrice }}</div>
          </div>
        </div>
      </div>
      <div class="box_detail_input marginFx">
        <div class="input-wrap">
          <span class="prompt"
            >库存{{ dropDownOptional.stockQuantity || 0 }}件<span class="inchesTips">（情侣款需成对下单）</span>，可选择不同规格</span
          >
          <span class="prompt placeNum">购买数量：</span>
          <el-input-number
            v-model="maleDataFrom.quantity"
            :min="dropDownOptional.stockQuantity > 0 ? 1 : 0"
            :max="maleStockQuantity"
            label="描述文字"
            @change="getSizeRange($event, 'quantity', '男')"
          ></el-input-number>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getOptional, getPriceRangeSpot } from '@/api/detailsApi';
import { deepClone } from '@/utils/util';
import { Decimal } from 'decimal.js';

export default {
  name: '',
  props: {
    DataList: {
      type: Object,
      default() {
        return {};
      },
    },
    settlementMethodList: {
      type: Array,
      default() {
        return [];
      },
    },
    leastQuantity: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      spotActive: 'first',
      dataFrom: {
        styleNumber: this.DataList.styleNumber,
        productName: this.DataList.productName,
        isCouples: this.DataList.isCouples,
        classify: 1,
        quantity: 0,
        shopType: 2,
        spotFlag: 1,
        ringSize: '',
        goldWeigh: '',
        lcTechnology: '',
        formatType: '',
        productRemark: '',
        gender: '女',
        tradePrice: '',
        labelPrice: '',
        exclusivePrice: '',
        settlementMethod: '',
      },
      maleDataFrom: {
        styleNumber: this.DataList.styleNumber,
        productName: this.DataList.productName,
        isCouples: this.DataList.isCouples,
        classify: 1,
        quantity: 0,
        shopType: 2,
        spotFlag: 1,
        ringSize: '',
        goldWeigh: '',
        lcTechnology: '',
        formatType: '',
        productRemark: '',
        gender: '男',
        tradePrice: '',
        labelPrice: '',
        exclusivePrice: '',
        settlementMethod: '',
      },
      dropDownOptional: {},
      formatTypes: [],
      lcTechnologList: [],
      goldenWeighList: [],
      handSizeList: [],
      maleFormatTypes: [],
      maleLcTechnologList: [],
      maleGoldenWeighList: [],
      maleHandSizeList: [],
      stockQuantity: 0,
      maleStockQuantity: 0,
      lcTechnologyIndex: 0,
      maleLcTechnologyIndex: 0,
      tradePrice: '',
      labelPrice: '',
      maleTradePrice: '',
      malelLabelPrice: '',
      settlementWeight: 0,
      maleSettlementWeight: 0,
    };
  },
  computed: {
    showSettlementMethod() {
      const displayFlag = this.dropDownOptional.factorySource != 1;
      return displayFlag;
    },
  },
  mounted() {
    this.dataFrom = { ...this.dataFrom, ...this.DataList };
    this.maleDataFrom = { ...this.maleDataFrom, ...this.DataList };
    this.getOptional();
  },
  methods: {
    emitGoldWeighState() {
      this.$emit('updateGoldWeighState', {
        shouldPrompt: this.goldenWeighList.length === 0 || this.maleGoldenWeighList.length === 0,
      });
    },
    defaultSelected() {
      // const hasLcTechnology = this.hasCurrentLcTechnology();
      // if (this.formatTypes.length == 1) {
      //   this.dataFrom.formatType = this.formatTypes[0];
      // }
      // if (this.maleFormatTypes.length == 1) {
      //   this.maleDataFrom.formatType = this.maleFormatTypes[0];
      // }
      // if (hasLcTechnology) {
      //   if (this.lcTechnologList.length == 1) {
      //     this.dataFrom.lcTechnology = this.lcTechnologList[0];
      //   }
      //   if (this.goldenWeighList.length == 1) {
      //     this.dataFrom.goldWeigh = this.goldenWeighList[0];
      //   }
      //   if (this.handSizeList.length == 1) {
      //     this.dataFrom.ringSize = this.handSizeList[0];
      //   }
      //   if (this.maleLcTechnologList.length == 1) {
      //     this.maleDataFrom.lcTechnology = this.maleLcTechnologList[0];
      //   }
      //   if (this.maleGoldenWeighList.length == 1) {
      //     this.maleDataFrom.goldWeigh = this.maleGoldenWeighList[0];
      //   }
      //   if (this.maleHandSizeList.length == 1) {
      //     this.maleDataFrom.ringSize = this.maleHandSizeList[0];
      //   }
      // } else {
      //   if (this.goldenWeighList.length == 1) {
      //     this.dataFrom.goldWeigh = this.goldenWeighList[0];
      //   }
      //   if (this.handSizeList.length == 1) {
      //     this.dataFrom.ringSize = this.handSizeList[0];
      //   }
      //   if (this.maleGoldenWeighList.length == 1) {
      //     this.maleDataFrom.goldWeigh = this.maleGoldenWeighList[0];
      //   }
      //   if (this.maleHandSizeList.length == 1) {
      //     this.maleDataFrom.ringSize = this.maleHandSizeList[0];
      //   }
      // }
    },
    handleClick(tab) {
      const gender = tab.name == 'first' ? '女' : '男';
      this.assembleOptionalData(gender);
      this.defaultSelected();
      this.fetchPriceRangeSpot(gender);
    },
    mainStoneSort(list) {
      const parsedRanges = list?.map((range) => {
        const [start, end] = range.split('-').map(parseFloat);
        return { start, end, range };
      });
      parsedRanges.sort((a, b) => a.start - b.start);
      return parsedRanges.map((item) => item.range);
    },
    sortFun(handSizeList) {
      return handSizeList?.sort(function (a, b) {
        return a - b;
      });
    },
    hasCurrentLcTechnology() {
      return this.dataFrom.settlementMethod == 2 ? this.dropDownOptional.materLcTechnologyFlag == 1 : this.dropDownOptional.lcTechnologyFlag == 1;
    },
    getCurrentCouplesMap(gender) {
      return this.dataFrom.settlementMethod == 1
        ? this.dropDownOptional.couplesMap?.[gender] || {}
        : this.dropDownOptional.materCouplesMap?.[gender] || {};
    },
    pickCurrentValue(list, value) {
      return list.includes(value) ? value : list[0] || '';
    },
    assembleOptionalData(gender) {
      const isFemale = gender == '女';
      const form = isFemale ? this.dataFrom : this.maleDataFrom;
      const currentCouplesMap = this.getCurrentCouplesMap(gender);
      const hasLcTechnology = this.hasCurrentLcTechnology();
      const formatTypes = this.dropDownOptional.formatTypeFlag == 1 ? Object.keys(currentCouplesMap) : [];
      const currentFormatType = this.dropDownOptional.formatTypeFlag == 1 ? this.pickCurrentValue(formatTypes, form.formatType) : '';
      const currentFormatMap = this.dropDownOptional.formatTypeFlag == 1 ? currentCouplesMap[currentFormatType] || {} : currentCouplesMap;

      if (isFemale) {
        this.formatTypes = formatTypes;
      } else {
        this.maleFormatTypes = formatTypes;
      }

      if (hasLcTechnology) {
        const lcTechnologyList = Object.keys(currentFormatMap);
        const currentLcTechnology = this.pickCurrentValue(lcTechnologyList, form.lcTechnology);
        const currentLcTechnologyMap = currentFormatMap[currentLcTechnology] || {};
        const goldenWeighList = this.mainStoneSort(Object.keys(currentLcTechnologyMap));
        const currentGoldWeigh = this.pickCurrentValue(goldenWeighList, form.goldWeigh);
        const handSizeList = this.sortFun(
          currentGoldWeigh ? currentLcTechnologyMap[currentGoldWeigh] || [] : Object.values(currentLcTechnologyMap)[0] || [],
        );

        if (isFemale) {
          this.lcTechnologList = lcTechnologyList;
          this.lcTechnologyIndex = this.lcTechnologList.indexOf(currentLcTechnology);
          this.goldenWeighList = goldenWeighList;
          this.handSizeList = handSizeList;
        } else {
          this.maleLcTechnologList = lcTechnologyList;
          this.maleLcTechnologyIndex = this.maleLcTechnologList.indexOf(currentLcTechnology);
          this.maleGoldenWeighList = goldenWeighList;
          this.maleHandSizeList = handSizeList;
        }
      } else {
        const goldenWeighList = this.mainStoneSort(Object.keys(currentFormatMap));
        const currentGoldWeigh = this.pickCurrentValue(goldenWeighList, form.goldWeigh);
        const handSizeList = this.sortFun(currentGoldWeigh ? currentFormatMap[currentGoldWeigh] || [] : Object.values(currentFormatMap)[0] || []);

        if (isFemale) {
          this.lcTechnologList = [];
          this.lcTechnologyIndex = 0;
          this.goldenWeighList = goldenWeighList;
          this.handSizeList = handSizeList;
        } else {
          this.maleLcTechnologList = [];
          this.maleLcTechnologyIndex = 0;
          this.maleGoldenWeighList = goldenWeighList;
          this.maleHandSizeList = handSizeList;
        }
      }
    },
    getOptional() {
      const obj = {
        styleNumber: this.DataList.styleNumber,
        classify: 1,
        spotFlag: 1,
        gender: '',
        otherType: this.$route.query.codeType == 'gold18_style' ? 2 : null,
      };
      getOptional(obj).then((res) => {
        this.dropDownOptional = { ...this.dropDownOptional, ...res.data };
        this.$emit('updateFactorySource', this.dropDownOptional.factorySource);
        if (this.dropDownOptional.materStockQuantity > 0 && this.dropDownOptional.factorySource != '1') {
          this.dataFrom.settlementMethod = 2;
          this.maleDataFrom.settlementMethod = 2;
        } else {
          this.dataFrom.settlementMethod = 1;
          this.maleDataFrom.settlementMethod = 1;
        }
        this.assembleOptionalData('女');
        this.assembleOptionalData('男');
        this.emitGoldWeighState();
        this.defaultSelected();
        this.$emit('upDataStockQuantity', this.dropDownOptional.stockQuantity);
        this.fetchPriceRangeSpot(this.spotActive == 'first' ? '女' : '男');
      });
    },
    resetFormBySettlement(form) {
      form.formatType = '';
      form.lcTechnology = '';
      form.goldWeigh = '';
      form.ringSize = '';
    },
    getSizeRange(value, type, gender) {
      if (type == 'settlementMethod') {
        this.dataFrom.settlementMethod = value;
        this.maleDataFrom.settlementMethod = value;
        this.resetFormBySettlement(this.dataFrom);
        this.resetFormBySettlement(this.maleDataFrom);
        this.lcTechnologyIndex = 0;
        this.maleLcTechnologyIndex = 0;
        this.assembleOptionalData('女');
        this.assembleOptionalData('男');
        this.emitGoldWeighState();
        this.defaultSelected();
        this.fetchPriceRangeSpot(gender);
        return;
      }

      const isFemale = gender == '女';
      const form = isFemale ? this.dataFrom : this.maleDataFrom;
      form[type] = value;

      if (type == 'formatType') {
        form.lcTechnology = '';
        form.goldWeigh = '';
        form.ringSize = '';
        if (isFemale) {
          this.lcTechnologyIndex = 0;
        } else {
          this.maleLcTechnologyIndex = 0;
        }
      }
      if (type == 'lcTechnology') {
        form.goldWeigh = '';
        form.ringSize = '';
      }
      if (type == 'goldWeigh') {
        form.ringSize = '';
      }

      if (['formatType', 'lcTechnology', 'goldWeigh'].includes(type)) {
        this.assembleOptionalData(gender);
        this.emitGoldWeighState();
        this.defaultSelected();
        this.fetchPriceRangeSpot(gender);
        return;
      }

      this.defaultSelected();
      this.fetchPriceRangeSpot(gender);
    },
    fetchPriceRangeSpot(gender) {
      const obj = gender == '女' ? deepClone(this.dataFrom) : deepClone(this.maleDataFrom);
      // 校验逻辑：有版型校验版型，无版型校验金重
      const hasFormat = gender == '女' ? this.formatTypes?.length > 0 : this.maleFormatTypes?.length > 0;
      // if (hasFormat) {
      //   if (!obj.formatType) return;
      // } else {
      //   if (!obj.goldWeigh) return;
      // }
      delete obj.texture;
      // if (
      //   !obj.formatType &&
      //   ((gender == '女' && this.formatTypes && this.formatTypes.length > 0) ||
      //     (gender == '男' && this.maleFormatTypes && this.maleFormatTypes.length > 0))
      // ) {
      //   return;
      // }
      if (obj.quantity == 0) obj.quantity = 1;
      getPriceRangeSpot(obj).then((res) => {
        if (gender == '女') {
          if (obj.goldWeigh) {
            if (obj.goldWeigh?.includes('-')) {
              this.settlementWeight = new Decimal(obj.goldWeigh.split('-')[1]).mul(obj.quantity).toFixed(2);
            } else {
              this.settlementWeight = new Decimal(obj.goldWeigh).mul(obj.quantity).toFixed(2);
            }
          } else this.settlementWeight = 0;
          this.tradePrice = res.data.tradePrice;
          this.labelPrice = res.data.labelPrice;
          this.dataFrom.tradePrice = res.data.tradePrice;
          this.dataFrom.labelPrice = res.data.labelPrice;
          this.dataFrom.exclusivePrice = res.data.exclusivePrice;
          this.stockQuantity = res.data.stockQuantity;
          if ((!this.dataFrom.quantity || this.dataFrom.quantity == 0) && res.data.stockQuantity > 0) this.dataFrom.quantity = 1;
          if (this.dataFrom.quantity > res.data.stockQuantity || res.data.stockQuantity == 0) {
            this.dataFrom.quantity = res.data.stockQuantity;
          }
        } else {
          if (obj.goldWeigh) {
            if (obj.goldWeigh?.includes('-')) {
              this.maleSettlementWeight = new Decimal(obj.goldWeigh.split('-')[1]).mul(obj.quantity).toFixed(2);
            } else {
              this.maleSettlementWeight = new Decimal(obj.goldWeigh).mul(obj.quantity).toFixed(2);
            }
          } else this.maleSettlementWeight = 0;
          this.maleTradePrice = res.data.tradePrice;
          this.malelLabelPrice = res.data.labelPrice;
          this.maleDataFrom.tradePrice = res.data.tradePrice;
          this.maleDataFrom.labelPrice = res.data.labelPrice;
          this.maleDataFrom.exclusivePrice = res.data.exclusivePrice;
          this.maleStockQuantity = res.data.stockQuantity;
          if ((!this.maleDataFrom.quantity || this.maleDataFrom.quantity == 0) && res.data.stockQuantity > 0) this.maleDataFrom.quantity = 1;
          if (this.maleDataFrom.quantity > res.data.stockQuantity || res.data.stockQuantity == 0) {
            this.maleDataFrom.quantity = res.data.stockQuantity;
          }
        }
        this.dropDownOptional.stockQuantity = res.data.stockQuantity;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.loverSortBox {
  margin-bottom: 10px;
  position: relative;

  .spotTabs .el-tabs__nav {
    width: 100%;
  }

  .spotTabs .el-tabs__item {
    text-align: center;
  }

  .spotTabs .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    border-bottom: #e4e7ed;
    background: #ec9368;
    color: #fff;
  }

  .spotTabs .el-tabs--card > .el-tabs__header .el-tabs__item.is-active:hover {
    color: #fff !important;
  }

  .spotTabs .el-tabs__item:hover {
    color: #ec9368 !important;
  }

  .loverPricesPrompt {
    font-size: 13px;
    color: red;
    position: absolute;
    top: 40px;
    z-index: 1;
  }

  .el-select-dropdown__item {
    margin: 10px 0 0 10px;
    display: inline-block;
    height: 46px;
    text-align: center;
    line-height: 46px;
    border: 1px solid #d3d3d3;
    padding: 0;
    font-size: 16px;
    color: #000;
  }

  .el-select-dropdown__item.selected {
    background: #fff2ea;
    font-size: 16px;
    color: #000;
    font-weight: 400;
    border: 1px solid #ee9c75;
  }
}

.custom {
  .fx {
    position: relative;
    margin: 8px 0;
  }

  .fl {
    display: flex;
    align-items: center;
    position: relative;
  }

  .selectBox {
    ::v-deep .el-popper {
      left: 0 !important;
    }

    .el-scrollbar__view li {
      width: 178px;
    }
  }

  .selectBoxWatch {
    .el-scrollbar__view li {
      min-width: 90px;
    }
  }

  .inchesFix {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .inchesTips {
    color: #ec9368;
  }

  .material {
    width: 800px;

    ::v-deep .el-radio-button__inner {
      min-width: 65px;
    }
  }

  .title {
    font-size: 18px;
    color: #000;
    display: inline-block;
    margin-bottom: 8px;

    .hidden {
      visibility: hidden;
    }
  }

  .value-font {
    font-size: 18px;
    color: #ec9368;
  }

  .mainStoneClssBoxFx {
    width: 675px;
    display: flex;
    align-items: center;
    position: relative;
  }

  ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    color: #fff;
    background-color: #ec9368;
    border-color: #ec9368;
    box-shadow: none;
  }

  ::v-deep .el-radio-button__inner:hover {
    color: rgb(236, 147, 104);
  }

  ::v-deep .el-radio-button__inner {
    margin: 5px;
    border-left: 1px solid #dcdfe6;
    border-radius: 4px;
  }

  ::v-deep .inchesFix:first-child .el-radio-button__inner {
    margin-left: 0;
  }

  ::v-deep .el-radio-group {
    display: flex;
    flex-wrap: wrap;
  }

  .input-wrap {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
  }

  .price-wrap {
    justify-content: flex-end;
  }

  .price-tips {
    color: red;
    margin-right: 10px;
  }
}
</style>
